import React from 'react';
import AdminPageHeader from '../../components/common/AdminPageHeader';
import BankAccountsApprovalSection from '../../components/admin/BankAccountsApprovalSection';

/**
 * 🏦 Página de Aprovação de Contas Bancárias (Admin)
 * 
 * Página dedicada para administradores aprovarem/rejeitarem contas bancárias
 */
const AdminBankAccountsPage = () => {
  return (
    <div className="container-fluid p-4">
      <AdminPageHeader
        icon="solar:card-bold"
        title="Aprovação de Contas Bancárias"
        subtitle="Gerencie e aprove as solicitações de cadastro de contas bancárias dos usuários"
      />

      <BankAccountsApprovalSection />
    </div>
  );
};

export default AdminBankAccountsPage;

